import cn from 'classnames'
import React, { forwardRef } from 'react'

import MenuListLabel, { MenuListLabelProps } from '../MenuListLabel'
import styles from './MenuListItem.module.scss'

export type MenuListItemProps = MenuListLabelProps & {
  children?: React.ReactNode
  type?: 'button' | 'checkbox'
  labelClassName?: MenuListLabelProps['labelClassName']
}

function MenuListItem({ children, ...props }: MenuListItemProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <li role="none" className={cn(styles.root)}>
      {typeof children === 'string' ? (
        <MenuListLabel ref={ref} {...props}>
          {children}
        </MenuListLabel>
      ) : (
        children
      )}
    </li>
  )
}

export default forwardRef(MenuListItem)
